import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import UserContext from '../context/UserContext';
import Config from '../../Config';
import i18n from '../i18next/i18next';

import '../../assets/css/pledge.css';

class PrivacyPledge extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  renderContent = language => {
    return (
    <Fragment>
    <div className="page_content">
        <div className="container_pledge full_box bg01">
            <div className="section">
                <p className="title t01">
                    {i18n.t('privacyPledge.title1', { lng: language })}
                </p>
            </div>
        </div>
        <div className="container_pledge txt_box">
            <div className="section">
                <p className="text">{i18n.t('privacyPledge.slogan1', { lng: language })}</p>
            </div>
        </div>

        <div className="container_pledge full_box bg02">
            <div className="section">
                <p className="title t02">{i18n.t('privacyPledge.title2', { lng: language })}</p>
            </div>
        </div>

        <div className="container_pledge txt_box">
            <div className="section">
                <p className="text">{i18n.t('privacyPledge.slogan2', { lng: language })}</p>
            </div>
        </div>

        <div className="container_pledge feature_box">
            <div className="feature_item">
                <div className="item_up">
                    <div className="feature_icon icon1"></div>
                </div>
                <div className="item_down">
                    <p className="title">{i18n.t('privacyPledge.title3', { lng: language })}</p>
                    <p className="txt">{i18n.t('privacyPledge.slogan3', { lng: language })}</p>
                </div>
            </div>
            <div className="feature_item">
                <div className="item_up">
                    <div className="feature_icon icon2"></div>
                </div>
                <div className="item_down">
                    <p className="title">{i18n.t('privacyPledge.title4', { lng: language })}</p>
                    <p className="txt">{i18n.t('privacyPledge.slogan4', { lng: language })}</p>
                </div>
            </div>
            <div className="feature_item">
                <div className="item_up">
                    <div className="feature_icon icon3"></div>
                </div>
                <div className="item_down">
                    <p className="title">{i18n.t('privacyPledge.title5', { lng: language })}</p>
                    <p className="txt">{i18n.t('privacyPledge.slogan5', { lng: language })}</p>
                </div>
            </div>
        </div>
        <div className="container_pledge moreinfo_box">
            {i18n.t('privacyPledge.moreInfo', { lng: language })}&nbsp;
            <a href="https://sso.dlink.com/privacy-policy" target="_blank">
                https://sso.dlink.com/privacy-policy
            </a>
        </div>
      </div>
      </Fragment>
    );
  };

  render() {
    return (
      <UserContext.Consumer>
        {({ language }) => this.renderContent(language)}
      </UserContext.Consumer>
    );
  }
}

export default PrivacyPledge;



// WEBPACK FOOTER //
// ./src/components/policy/PrivacyPledge.js